import * as React from 'react';
import Bottom from '@src/components/Bottom';
import Header from '@component/Header';
import { OpenApiDoMain } from '@src/constants'
import Item from '@component/Item'
import AlertMessage from '@component/AlertMessage'
import ReturnTop from '@component/ReturnTop'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import './style.scss';
import axios from 'axios'

interface IState {
  showAlert: boolean,
  active: number,
  itemList: any
}

class Home extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      showAlert: false,
      active: 1,
      itemList: []
    }
    // 改变方法内的this指向
    this.showAlertMessage = this.showAlertMessage.bind(this);
  }

  public showAlertMessage() {
    this.setState({ showAlert: true });
    setTimeout(() => {
      this.setState({ showAlert: false });
    }, 2000);
  }

  public getList() {
    const that = this
    axios.get(OpenApiDoMain + '/article?pageSize=7&currentPage=1&channel=yuqinet.com&hot=&tag=')
      .then((res) => {
        that.setState({
          itemList: res.data.data
        });
      })
  }

  public getItem() {
    if (this.state.itemList.length > 0) {
      return (this.state.itemList.map((item: any, key: number) => {
        return (<Item key={key} index={item.id} item={item} pc={true} />)
      }))
    }
    return
  }

  public componentDidMount() {
    this.getList()
    const location = this.props.location.state ? this.props.location.state.location : ''
    if (location === 'news') {
      this.scrollTo('news')
    } else if (location === 'game') {
      this.scrollTo('ourGame')
    }
    const mySwiper = new Swiper('#pcSwiper', {
      autoplay: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    });
    console.log(mySwiper);
  }

  public scrollTo(id: string) {
    const anchorElement = document.getElementById(id);
    if (anchorElement) {
      window.scrollTo({ top: anchorElement.offsetTop, behavior: "smooth" });
    }
  }

  public toNews() {
    location.href = '/news'
  }

  public toAboutUs() {
    location.href = '/aboutUs'
  }

  public toJoinUs() {
    location.href = '/joinUs'
  }

  public openGameDeatil(detailIndex: number) {
    location.href = '/gameDetail/' + detailIndex
  }

  public openNewsDeatil(detailIndex: number) {
    location.href = '/detail/' + detailIndex
  }

  public render() {
    return (
      <div className="home">
        <Header current="home" />
        <img className="banner" src={require('@static/pc/WEB-pc_01.png')} alt="域起官网" />
        <div id="ourGame" className="our-game">
          <div className="title">我们的游戏</div>
          <div className="img-content">
            <img onClick={this.showAlertMessage} src={require('@static/ourGame/1.png')} alt="域起官网" />
            <img onClick={this.showAlertMessage} src={require('@static/ourGame/2.jpg')} alt="域起官网" />
            <img onClick={this.showAlertMessage} src={require('@static/ourGame/3.jpg')} alt="域起官网" />
            <img onClick={this.showAlertMessage} src={require('@static/ourGame/4.jpg')} alt="域起官网" />
            <img onClick={this.openGameDeatil.bind(this, 4)} src={require('@static/ourGame/5.jpg')} alt="域起官网" />
            <img onClick={this.openGameDeatil.bind(this, 2)} src={require('@static/ourGame/6.jpg')} alt="域起官网" />
            <img onClick={this.openGameDeatil.bind(this, 1)} src={require('@static/ourGame/7.jpg')} alt="域起官网" />
            <img onClick={this.openGameDeatil.bind(this, 3)} src={require('@static/ourGame/8.jpg')} alt="域起官网" />
            <div onClick={this.showAlertMessage} className="get-more">MORE +</div>
          </div>
        </div>
        <div id="news" className="news">
          <div className="title">新闻和资讯</div>
          <div className="news-content">
            <div id='pcSwiper' className="swiper-container">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <img onClick={this.openNewsDeatil.bind(this, 29)} src={require('@static/yqwl.jpg')} alt="域起官网" />
                  <div>用年轻创造无限可能，我们的目标是星辰大海</div>
                </div>
                <div className="swiper-slide">
                  <img onClick={this.openNewsDeatil.bind(this, 30)} src={require('@static/xwu44.jpg')} alt="域起官网" />
                  <div>【中秋寄语】《梦幻炫舞》中秋节活动预告</div>
                </div>
                <div className="swiper-slide">
                  <img onClick={this.openNewsDeatil.bind(this, 28)} src={require('@static/wsgdw.jpg')} alt="域起官网" />
                  <div>四域同起 问鼎金陵2019“GG游戏”杯苏皖城市掼蛋联赛正式启动！</div>
                </div>
              </div>
              <div className="swiper-pagination" />
            </div>
            <div className="item-list">
              {this.getItem()}

            </div>
          </div>
          {
            this.state.itemList.length > 7
              ? (<div onClick={this.toNews} className="check-more">查看更多&gt;&gt;</div>)
              : ''
          }
        </div>
        <div id="weAreIn" className="we-are-in-yq">
          <div className="title">我们在域起</div>
          <div className="we-are-content">
            <div>
              <img className="office" src={require('@static/pc/WEB-pc_29.jpg')} alt="域起官网" />
            </div>
            <div className="office-right">
              <div onClick={this.toAboutUs} className="about-us"><span>关于我们</span></div>
              <img className="child-1" src={require('@static/pc/WEB-pc_33.jpg')} alt="域起官网" />
              <img className="child-2" src={require('@static/pc/WEB-pc_35.jpg')} alt="域起官网" />
              <img className="child-3" src={require('@static/pc/WEB-pc_42.jpg')} alt="域起官网" />
              <div onClick={this.toJoinUs} className="join-us">
                <div>
                  <div>我们正在等待你的加入</div>
                  <div>加入我们</div>
                </div>
              </div>
              <img className="child-4" src={require('@static/pc/WEB-pc_41.jpg')} alt="域起官网" />
            </div>
          </div>
        </div>
        <AlertMessage message="敬请期待" show={this.state.showAlert} />
        <ReturnTop />
        <Bottom />
      </div>
    );
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/index.tsx